import React from 'react';
import "./Login.css"
const Pagination = ({selectedModuleSlide,modulesInfo,handleChangeModuleSlide}) => {
  return (
    <div className="pagination">
        {
            modulesInfo?.map((val,index)=>{
                return (
                    <div onClick={()=>handleChangeModuleSlide(index)} className={`dot ${selectedModuleSlide===index ? 'active':""}`}></div>
                )
            })
        }
 
    </div>
  );
};

export default Pagination;
